'use strict';

import './vdpAbandonCapture.scss';
import template from './vdpAbandonCapture.template.html';
import controller from './vdpAbandonCapture.controller.js';

const component = {
    bindings: {},
    controller,
    template
};

export default component;
